import React, { useState } from 'react';
import GrampanchayatPadadhikari from '../Grampanchayat/GrampanchayatPadadhikari';
import GavachiMulbhutMahiti from '../Grampanchayat/GavachiMulbhutMahiti';
import GavatilSuvidhaMahiti from '../Grampanchayat/GavatilSuvidhaMahiti';
import { FaUserTie, FaHome, FaHandshake } from 'react-icons/fa';

const Grampanchayatnivaad = () => {
  const [activeTab, setActiveTab] = useState('padadhikari');

  const tabs = [
    {
      id: 'padadhikari',
      label: 'ग्रामपंचायत पदाधिकारी माहिती',
      icon: <FaUserTie className="w-5 h-5" />,
      component: <GrampanchayatPadadhikari />
    },
    {
      id: 'mulbhut',
      label: 'गावाची मूलभूत माहिती',
      icon: <FaHome className="w-5 h-5" />,
      component: <GavachiMulbhutMahiti />
    },
    {
      id: 'suvidha',
      label: 'गावातील सुविधा माहिती',
      icon: <FaHandshake className="w-5 h-5" />,
      component: <GavatilSuvidhaMahiti />
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-[#267c77] text-white py-8 px-4 md:px-8 shadow-lg">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-4 md:mb-0 text-center md:text-left">
              <h1 className="text-3xl md:text-4xl font-bold mb-2">ग्रामपंचायत व्यवस्थापन</h1>
              <p className="text-emerald-100 text-lg">गावाचा सर्वांगीण विकास आणि प्रशासन</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 -mt-8">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden min-h-[600px]">
          {/* Navigation Tabs */}
          <div className="flex flex-wrap border-b border-gray-200 bg-white sticky top-0 z-10">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 flex items-center justify-center space-x-3 py-5 px-4 text-sm md:text-base font-bold uppercase tracking-wide transition-all duration-300 ${
                  activeTab === tab.id
                    ? 'text-[#267c77] border-b-4 border-[#267c77] bg-teal-50/50'
                    : 'text-gray-500 hover:text-[#267c77] hover:bg-gray-50'
                }`}
              >
                <span className={`transform transition-transform ${activeTab === tab.id ? 'scale-110' : ''}`}>
                  {tab.icon}
                </span>
                <span>{tab.label}</span>
              </button>
            ))}
          </div>

          {/* Render Active Component */}
          <div className="p-6 md:p-8 bg-gray-50/30">
            <div className="animate-fade-in">
              {tabs.find(t => t.id === activeTab)?.component}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-12 py-8">
        <div className="max-w-7xl mx-auto px-4 text-center text-gray-500">
          <p>© 2024 ग्रामपंचायत डिजिटल प्रणाली. सर्व हक्क राखीव.</p>
        </div>
      </footer>
    </div>
  );
};

export default Grampanchayatnivaad;